import { takeLatest, put, call, fork } from "redux-saga/effects";
import { StageService } from "services";
import { message } from "antd";
import { fetchedStagesList, failedFetchStagesList } from "actions";
import { STAGE_ACTIONS } from "constants";
import { Range } from "immutable";

function* stagesListHandler() {
    try {
        const { data, error } = yield call(
            StageService.getStageList,
            Range(1, 25).toArray()
        );
        if (!error) {
            yield put(fetchedStagesList(data.results));
        } else {
            message.error("Failed to Fetch Stage List", 2);
            yield put(failedFetchStagesList(error));
        }
    } catch (error) {
        message.error("Failed to Fetch Stage List", 2);
        yield put(failedFetchStagesList(error));
    }
}

export default fork(function*() {
    yield takeLatest(STAGE_ACTIONS.FETCH_STAGES_LIST, stagesListHandler);
});
